import { createFileRoute } from "@tanstack/react-router";
import { Suspense } from "react";
import { PageTransition } from "@/components/PageTransition";
import Portfolio from "@/pages/Portfolio";

export const Route = createFileRoute("/portfolio")({
  component: PortfolioRoute,
});

function PortfolioRoute() {
  return (
    <PageTransition>
      <Suspense fallback={<div className="min-h-screen bg-background" />}>
        <Portfolio />
      </Suspense>
    </PageTransition>
  );
}
